
<template>
  <div>
    <Button @click="openQueryBox" ref="queryBtn" class="search-btn" type="primary" icon="ios-search">搜索</Button>
    <transition name="fade">
      <div v-show="showQueryBox" class="queryBox-content">
        <!-- <div class="queryBox-arrow" ref="queryArrow" :style="{'margin-left':arrowLeft+'px'}"></div> -->
        <div slot="content">
            搜索项目内容
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      arrowLeft:30,
      showQueryBox: false
    };
  },
  methods: {
    openQueryBox() {
      this.setArrowPosition();
      this.showQueryBox = !this.showQueryBox;
    },
    setArrowPosition(){
      //设置箭头位置对准搜索按钮
      console.log(this.$refs.queryBtn.$el.offsetLeft);
       this.arrowLeft=this.$refs.queryBtn.$el.offsetLeft;
    }
  },
  mounted(){
   
  }
};
</script>
<style lang="less">
.queryBox {
  &-content {
    margin-top: 20px;
    position: relative;
    height: auto;
    background: rgb(255, 255, 255);
    box-shadow: 1px 2px 3px #dcdee2;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    text-align: center;
    color: red;
  }
  &-arrow {
    position: absolute;
    top: -7px;
    left: 30px;
    overflow: hidden;
    width: 13px;
    height: 13px;
    background: rgb(255, 255, 255);
    border-left: 1px solid #dcdee2;
    border-top: 1px solid #dcdee2;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}
</style>